import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody } from 'react-accessible-accordion'
import { ProductStyle, AccordionComponent, AccordionIcon } from './ProductDetail.style'
import { PrimaryButton, ButtonArrow } from '../../../shared/Buttons/Buttons.styles'
import ArrowRight from '../Icons/ArrowRight'
import Image from '../../../shared/Image'
import Link from '../../../shared/Link'
import 'react-accessible-accordion/dist/minimal-example.css'

const ProductDetail = ({ item, animate, productBackgroundImage }) => (
  <ProductStyle>
    <div
      className={
        (productBackgroundImage ? 'productImageContainer hasBackground' : 'productImageContainer') + ' ' +
        (animate && 'wow fadeInLeft')
      }
      style={{
        backgroundImage: `url(${productBackgroundImage})`,
      }}
    >
      {item.image.imageFile.file ? (
        <Image
          src={item.image.imageFile.file.url}
          className="productImage"
          alt={item.image.altText}
          title={item.image.imageTitle}
        />
      ) : null}

    </div>
    <div className="productDetails">
      { item.logos &&
      item.logos.length && (
        <div className="productLogos">
          { item.logos.map(logo => {
            return (
              <Image
                src={logo.imageFile.file.url}
                alt={logo.altText}
                title={logo.imageTitle}
                key={logo.id}
              />
            )
          })
          }
        </div>
      )
      }

      {item.title && <h4>{item.title}</h4>}

      {item.productSpecification && (
        <Fragment>
          <AccordionComponent className="productSpec">
            <Accordion>
              <AccordionItem>
                <AccordionItemBody>
                  <div
                    className="productDescription"
                    dangerouslySetInnerHTML={{
                      __html:
                        item.productSpecification.childMarkdownRemark
                          .html,
                    }}
                  />
                </AccordionItemBody>
                <AccordionItemTitle className="accordian-header">
                  <AccordionIcon />
                </AccordionItemTitle>
              </AccordionItem>
            </Accordion>
          </AccordionComponent>
          <div
            className="productDescription desktopDesc"
            dangerouslySetInnerHTML={{
              __html:
                item.productSpecification.childMarkdownRemark.html,
            }}
          />
        </Fragment>
      )}

      {item.ctaLabel && (
        <PrimaryButton className="productButton">
          <Link to={item.ctaLink}>
            {item.ctaLabel}
            <ButtonArrow viewBox="0 0 12 21"><ArrowRight /></ButtonArrow>
          </Link>
        </PrimaryButton>
      )}
    </div>
  </ProductStyle>
)

ProductDetail.propTypes = {
  item: PropTypes.shape({
    productImage: PropTypes.shape({
      file: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
    productSpecification: PropTypes.shape({
      childMarkdownRemark: PropTypes.shape({
        html: PropTypes.string.isRequired,
      }),
    }).isRequired,
    ctaLink: PropTypes.string,
    ctaLabel: PropTypes.string,
  }).isRequired,
  logos: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  animate: PropTypes.bool,
  productBackgroundImage: PropTypes.string,
}

ProductDetail.defaultProps = {
  logos: null,
  animate: false,
  productBackgroundImage: null,
}

export const ProductDetailFragment = graphql`
fragment ProductDetailFragment on ContentfulProductDetails {
  id
  title
  ctaLabel
  ctaLink
  productSpecification {
    childMarkdownRemark {
      html
    }
  }
  logos {
    ...ImageFragment
  }
  image {
    ...ImageFragment
  }
}
`

export default ProductDetail
